import React from "react"
import { usePageContext } from "vike-react/usePageContext"
import BlogPost from "../Blog/post"

const BlogPostPage = () => {
  const pageContext = usePageContext()

  // Extract postID from URL pathname (e.g., /blog/my-post-slug or /ru/blog/my-post-slug)
  const pathname = pageContext?.urlPathname || (typeof window !== 'undefined' ? window.location.pathname : '')
  const pathSegments = pathname.split('/').filter(Boolean)

  // Check if first segment is a language code (2-letter code)
  const hasLangCode = pathSegments[0]?.length === 2 && pathSegments[0].match(/^[a-z]{2}$/)

  // Get the slug: if language code present, it's at index 2, otherwise at index 1
  const postID = hasLangCode ? pathSegments[2] : pathSegments[1]

  if (!postID) {
    return <div>Error: No post ID found in the URL.</div>
  }

  return <BlogPost postID={postID} />
}

// onBeforeRender hook for blog post meta tags
export const onBeforeRender = async (pageContext) => {
  const requestPath = pageContext.urlParsed?.pathname || pageContext.urlPathname || '/'

  // Match both /blog/slug and /xx/blog/slug (where xx is language code)
  const blogPostMatch = requestPath.match(/^(?:\/([a-z]{2}))?\/blog\/(.+)$/)

  if (!blogPostMatch) {
    return {}
  }

  const langCode = blogPostMatch[1] // Language code (if present)
  const slug = blogPostMatch[2] // Blog post slug


  try {
    const { GetCMSContent } = await import('aldoo-ra/CMS/api')
    const { url } = await import('aldoo-ra/CMS/url')

    const response = await GetCMSContent({
      page: 1,
      itemsPerPage: 1,
      match: {
        'content.type': 'BlogPost',
        'content.slug': slug
      },
      expand: true,
      language: langCode || 'en' // Pass language for server-side localization
    })


    if (response.data && response.data.length > 0) {
      // API returns data directly at response.data[0], not nested in .content
      const post = response.data[0]

      // Use SEO fields if available, fallback to regular fields
      const seoTitle = post.seo_title || post.title || 'Blog Post'
      const seoDescription = post.seo_description || post.title || 'Read our latest blog post'
      const seoImage = post.seo_image || post.thumbnail || '/static/images/og_image.jpg'

      // Join tags array if it exists
      const tags = Array.isArray(post.tags) ? post.tags.join(', ') : ''

      // Build canonical URL (without language prefix for default language)
      const baseUrl = typeof window !== 'undefined'
        ? `${window.location.protocol}//${window.location.host}`
        : 'https://aqua-mail.com' // Fallback for SSR

      const canonicalPath = langCode && langCode !== 'en'
        ? `/${langCode}/blog/${slug}`
        : `/blog/${slug}`

      const canonicalUrl = `${baseUrl}${canonicalPath}`

      // Determine language tag (use detected language or default to 'en')
      const language = langCode || 'en'

      return {
        title: seoTitle,
        description: seoDescription,
        thumbnail: url(seoImage) || seoImage,
        tags: tags,
        metadata: {
          ogType: 'article',
          language: language,
          canonicalUrl: canonicalUrl
        }
      }
    }
  } catch (error) {
    console.error('BlogPostPage onBeforeRender ERROR:', error)
  }

  return {}
}

// Attach the onBeforeRender hook directly to the component for auto-discovery
BlogPostPage.onBeforeRender = onBeforeRender

export default BlogPostPage